import type {
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginContext,
    PluginHeuristicsRegistry
} from '../../types'
import * as flush from './flush'
import * as adaptive from './adaptive'
import {AlgorithmModes} from '../../enums'
import {generatePluginHandlerPerMode} from '../common'
import {getContainerRowCountKey} from './common'
import type {OrderPluginAPI} from './types'
import type {Pointer} from '@wix/document-services-types'
import {ORDERED_GROUPED_STRUCTURE_HASH_KEY} from './constants'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const orderRealStructureHeuristics = {
        [AlgorithmModes.Adaptive]: adaptive.createOrderRealStructure(readOnlyExtensionAPI),
        [AlgorithmModes.Flush]: flush.orderRealStructure(readOnlyExtensionAPI)
    }

    const positionHeuristics = {
        [AlgorithmModes.Adaptive]: adaptive.positionItems,
        [AlgorithmModes.Flush]: flush.positionItems
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.GROUPING_ORDER, flush.createOrderVirtualStructure(readOnlyExtensionAPI))
        registry.register(stages.STRUCTURE_ORDER, generatePluginHandlerPerMode(orderRealStructureHeuristics))
        registry.register(stages.POSITION, generatePluginHandlerPerMode(positionHeuristics))
        registry.registerPostStageOperation(stages.STRUCTURE_ORDER, flush.postStageOperation)
    }

    const createApi = (context: PluginContext): OrderPluginAPI => {
        return {
            getContainerRowCount: (containerPointer: Pointer): number | undefined =>
                context.get(getContainerRowCountKey(containerPointer)),
            getCalculatedHash: (): string | undefined => context.get(ORDERED_GROUPED_STRUCTURE_HASH_KEY)
        }
    }

    return {register, createApi, name: 'order', dependencies: []}
}
